import type { Dispatch } from 'react-redux';
import type * as TActions from '@actions';

type AppointmentStatus = {
  appointment_completed?: boolean;
  pat_start?: Date | null;
  pat_end?: Date | null;
  clin_start?: Date | null;
  clin_end?: Date | null;
};

// Misnomer: this function returns true if the appointment video call is in progress
const getAppointmentStati = async ({
  dispatch,
  actions,
  appointment_id,
  apptStati
}: {
  dispatch?: Dispatch;
  actions?: typeof TActions;
  appointment_id: number;
  apptStati: AppointmentStatus;
}) => {
  let appointment_stati: AppointmentStatus = {
    appointment_completed: undefined,
    pat_start: undefined,
    pat_end: undefined,
    clin_start: undefined,
    clin_end: undefined
  };
  if (apptStati) {
    appointment_stati = apptStati;
  } else if (dispatch && actions && appointment_id) {
    const appointmentStatusRes = await dispatch(actions.getAppointmentStatus(appointment_id));
    appointment_stati = appointmentStatusRes?.appointment_stati?.[0];
  }

  if (!appointment_stati) return false;

  const { clin_end, clin_start } = appointment_stati;

  if (clin_end) return false;

  return !!clin_start;
};

export { getAppointmentStati };
